import { render, staticRenderFns } from "./MicropointHistoryConsume.vue?vue&type=template&id=848f3292&scoped=true"
import script from "./MicropointHistoryConsume.vue?vue&type=script&lang=js"
export * from "./MicropointHistoryConsume.vue?vue&type=script&lang=js"
import style0 from "./MicropointHistoryConsume.vue?vue&type=style&index=0&id=848f3292&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "848f3292",
  null
  
)

export default component.exports